import { GlobalSessionData } from "../../interfaces/sessiondatamapper";

export function mapResponseToSessionData(response: any): GlobalSessionData {

    let sessionInfo =
    {
        BranchCode: "",
        BranchName: "",
        CustomerId: "0",
        CustomerName: "",
        DistributorId: "0",
        DistributorCode: "",
        DistributorName: "",        
        LocationId: "0",
        LocationName: "",
        SelectedView:"",
        punchOutRequestPartLogId: '',
        punchOutTid: '',
        punchOutUserAdId: '',
        SelectedStartDate: "",
        SelectedEndDate: "",
        LoggedInFrom: '',
        gridViewSelection:''
   };    
    sessionInfo.BranchCode = response.BranchCode;
    sessionInfo.BranchName = response.BranchName;
    sessionInfo.CustomerId = response.CustomerId;
    sessionInfo.CustomerName = response.CustomerName;
    sessionInfo.DistributorId = response.DistributorId;
    sessionInfo.DistributorCode = response.DistributorCode;
    sessionInfo.DistributorName = response.DistributorName; 
    sessionInfo.LocationId = response.LocationId;
    sessionInfo.LocationName = response.LocationName;
    sessionInfo.SelectedView = response.SelectedView;
    sessionInfo.punchOutRequestPartLogId = response.punchOutRequestPartLogId;
    sessionInfo.punchOutTid = response.punchOutTid;
    sessionInfo.punchOutUserAdId = response.punchOutUserAdId
    sessionInfo.SelectedStartDate = response?.SelectedStartDate ?? "";
    sessionInfo.SelectedEndDate = response?.SelectedEndDate ?? "";
    sessionInfo.LoggedInFrom = response.LoggedInFrom || response.loggedInFrom || "";
    sessionInfo.gridViewSelection = response.gridViewSelection || '';

    return sessionInfo as unknown as GlobalSessionData;
}